import { isUoBrandedAnnouncement } from '@uo/shared';
import { OtherPanel, SectionHeader, GlassPanel } from './WalletShared';
import { QueryErrorNote } from '../ui/QueryErrorNote';
import { COLORS, WALLET_COLORS as C } from '@/constants';
import { formatLedgerAction, formatLedgerDelta } from '../../utils/ledger-display';
import { tokenDisplayLabel } from '../../utils/orb-display';

type Translate = (key: string) => string;
type NewsRow = { id: number; title: string; body?: string; create_time: string };
type LedgerRow = {
  id: string;
  asset: string;
  action: string;
  delta: string;
  create_time: string;
};

export function RecentLedger({
  t,
  rows,
  error,
  onRetry,
}: {
  t: Translate;
  rows?: LedgerRow[];
  error?: string;
  onRetry?: () => void;
}) {
  return (
    <OtherPanel className="px-1.5 pb-3">
      <SectionHeader title={t('wallet.recentLedger')} />
      {error ? <QueryErrorNote message={error} onRetry={onRetry} /> : null}
      <div className="flex flex-col gap-0.5">
        {!rows?.length && <div className="border border-transparent px-4 py-8 text-center text-sm" style={{ background: `${C.bgAsset} padding-box, ${C.otherAsset} border-box`, boxShadow: C.shadowAsset, color: COLORS.iconColor }}>{t('history.noRecords')}</div>}
        {rows?.map((row) => {
          const delta = formatLedgerDelta(row.delta);
          return (
          <div key={row.id} className="flex min-h-[58px] items-center justify-between gap-3 border border-transparent px-3 py-3" style={{ background: `${C.bgAsset} padding-box, ${C.otherAsset} border-box`, boxShadow: C.shadowAsset }}>
            <div className="min-w-0">
              <div className="truncate text-sm font-semibold" style={{ color: COLORS.iconGlobal }}>{formatLedgerAction(row.action, t)}</div>
              <div className="truncate text-[10px]" style={{ color: COLORS.iconColor }}>{tokenDisplayLabel(row.asset ?? '')} · {row.create_time}</div>
            </div>
            <div className={`shrink-0 rounded-md px-2 py-1 font-mono text-sm font-semibold ${delta.isNegative ? 'bg-negative/10 text-negative' : 'bg-[#ADD741]/10 text-[#ADD741]'}`}>{delta.text}</div>
          </div>
          );
        })}
      </div>
    </OtherPanel>
  );
}

export function NewsList({
  t,
  rows,
  onMore,
  onSelect,
}: {
  t: Translate;
  rows: NewsRow[];
  onMore: () => void;
  onSelect?: (row: NewsRow) => void;
}) {
  const visible = rows.filter((row) => !isUoBrandedAnnouncement(row));
  if (visible.length === 0) return null;
  return (
    <GlassPanel className="overflow-hidden p-0">
      <SectionHeader title={t('wallet.latestNews')} action={t('common.more')} onAction={onMore} />
      <div className="divide-y divide-[#F5EC63]/20">
        {visible.map((n) => (
          <button
            key={`${n.create_time}-${n.id}-${n.title}`}
            type="button"
            onClick={() => (onSelect ? onSelect(n) : onMore())}
            className="flex w-full cursor-pointer items-center justify-between px-4 py-3 text-left active:bg-[#F5EC63]/10"
          >
            <span className="flex-1 truncate text-sm text-[#E5E7EB]">{n.title}</span>
            <span className="ml-2 shrink-0 text-[10px] text-[#9CA3AF]">{n.create_time?.slice(0, 10)}</span>
          </button>
        ))}
      </div>
    </GlassPanel>
  );
}